import React, { Component } from 'react'
import { withRouter } from "react-router-dom";
import { Button, Snackbar, Slide } from '@material-ui/core';
import Http from '../../../Http';
// import Http from '../../../Http';

class Sucursal extends Component {
  state = {
    sbOpen: false,
    sbMsg: '',
    autorizada: false,
    loadingAut: true,
  }

  componentDidMount() {
    console.log(this.props.preguia)
    this.autorizada();
  }

  autorizada = async () => {
    const { id } = this.props.preguia;
    try {
      let Res = await Http.get(`preguia/${id}/autorizada`);
      console.log(Res)
      if (!Res.error) {
        this.setState({ loadingAut: false, autorizada: Res.data });
      }
    } catch (error) {

    }
  }

  autorizar = async (sino = true) => {
    const { id } = this.props.preguia;
    try {
      if (sino) {
        let Res = await Http.post(`preguia/${id}/autorizar`, {autorizar: sino ? 1 : 0});
        // console.log(Res)
        if (!Res.error) {
          this.setState({ sbMsg: 'Preguía autorizada', sbOpen: true });
          this.autorizada();
          this.props.onClose();
        }
      } else {
        this.props.onClose();
      }
    } catch (error) {

    }
  }

  render() {
    const { sbOpen, sbMsg, loadingAut, autorizada } = this.state;
    return (
      <div style={{ padding: 20 }}>
        {/* <Paper style={{ padding: 12, textAlign: 'center' }}> */}
          {
            loadingAut &&
            <p>Cargando...</p>
          }
          {
            !loadingAut && autorizada &&
            <p>Esta guía ya fue autorizada por <strong>{autorizada.nombre} {autorizada.apellido_materno} {autorizada.apellido_paterno}</strong></p>
          }
          {
            !loadingAut && !autorizada &&
            (
              <div>
                {/* <h4>¿Autorizar preguía?</h4> */}
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                  <Button onClick={() => this.autorizar(false)} variant='outlined' color='primary' style={{ marginRight: 10 }}>No</Button>
                  <Button onClick={() => this.autorizar()} variant='contained' color='primary'>Sí</Button>
                </div>
              </div>)
          }
        {/* </Paper> */}
        <div>
          <Snackbar
            open={sbOpen}
            onClose={() => { this.setState({ sbOpen: false }) }}
            TransitionComponent={Slide}
            message={<span>{sbMsg}</span>}
          />
        </div>
      </div>
    )
  }
}

export default withRouter(Sucursal)
